<template>
  <div class="container-sm text-entry-control">
    <div
      class="text-entry-input-box"
      :class="{ focused: isFocused, 'has-error': reachedLimit, disabled: !isClassStudent }"
    >
      <AutosizeTextarea
        v-model="answerValue"
        :placeholder="$t('page_editor.text_entry.placeholder')"
        :limit="30"
        @focus="isFocused = true"
        @keyup="submit()"
        :disabled="!isClassStudent"
      >
      </AutosizeTextarea>
    </div>

    <div
      v-if="reachedLimit"
      class="typography-caption typography-color-alert text-center pt-2"
    >
      {{ $t('viewer.quiz_item.text_entry_control.alerts.max_length') }}
    </div>
    <div
      v-if="isInvalidEnteredValueLines"
      class="typography-caption typography-color-alert text-center pt-2"
    >
      {{ $t('viewer.quiz_item.text_entry_control.alerts.max_line_break') }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'text-entry-control',

  props: [
    'quiz',
  ],

  data() {
    return {
      answerValue: '',

      isFocused: false,

      startTime: new Date(),
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      cardId: 'getCardId',
      isEnd: 'getIsEnd',
      quizSolved: 'getQuizSolved',
      quizResult: 'getQuizResult',
      preEnteredValue: 'getPreEnteredValue',
      isClassStudent: 'isClassStudent',
      pagination: 'getPagesPagination',
      isInvalidEnteredValueLines: 'isInvalidEnteredValueLines',
    }),

    reachedLimit() {
      return this.answerValue.length >= 30;
    },

    submitDisabled() {
      return this.answerValue.length === 0;
    },
  },

  methods: {
    ...mapActions({
      saveQuizValue: 'saveQuizValue',
    }),

    goNextPage() {
      if (this.pagination.page < this.pagination.total) {
        this.$router.push({ name: 'pages.show', params: { page: this.pagination.page + 1 } });
      }
      if (this.pagination.page === this.pagination.total && !this.isEnd) {
        this.$router.push({ name: 'pages.confirm_submit', params: { cardId: this.cardId } });
      }
      if (this.pagination.page === this.pagination.total && this.isEnd) {
        this.$router.push({ name: 'cards.results', params: { cardId: this.cardId } });
      }
    },

    submit() {
      if (!this.isClassStudent) {
        this.goNextPage();
        return;
      }

      if (this.quizSolved) {
        return;
      }

      this.saveQuizValue({ quiz: this.quiz, value: this.answerValue });
      this.isFocused = false;
    },
  },

  beforeMount() {
    if (!isEmpty(this.preEnteredValue)) {
      this.answerValue = this.preEnteredValue;
    }
  },

  watch: {
    $route() {
      if (!isEmpty(this.preEnteredValue)) {
        this.answerValue = this.preEnteredValue;
      }

      if (isEmpty(this.preEnteredValue)) {
        this.answerValue = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .text-entry-control {
    padding-top: 40px;

    .text-entry-input-box {
      border-radius: 4px;
      background-color: #ffffff;
      border: solid 1px #cccccc;
      padding: 15px 16px;
      line-height: 18px;
      transition: border-color .5s ease, color .5s ease;

      &.focused {
        border: solid 1px #999999;
      }

      &.has-error {
        border: solid 1px #e91e63;
      }

      textarea {
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.29;
        color: rgba(0, 0, 0, 0.87);
        outline: none;
        padding: 0;
        border: none;
        vertical-align: top;
        user-select: auto !important;

        &::placeholder {
          color: rgba(0, 0, 0, 0.26);
        }

        &:disabled {
          background: #eeeeee;
        }
      }

      &.disabled {
        background: #eeeeee;
      }
    }

    .text-entry-btn-area {
      padding-top: 20px;
      margin-bottom: 16px;

      button {
        min-width: 120px;
      }
    }
  }
</style>
